import { getUserCredential } from "src/lib/cookies";
import projectSetting from "src/setting";

export const downloadFile = async (file, onProgress) => {
  const baseURL = projectSetting.baseURL + projectSetting.backend + projectSetting.version;
  const cookiesData = getUserCredential();

  const headers = {
    Connection: "keep-alive",
    "X-Access-Token": cookiesData?.secretToken || "",
    Accept: "application/json",
    "Content-Type": "application/json",
  };

  const body = {
    in_document_path: file.document_path,
    in_filter: null,
    in_sort_number: 1,
    in_sort_order: "ASC",
    in_content_type: file.document_type,
  };

  try {
    const response = await fetch(`${baseURL}/timesheet/download-document`, {
      method: "POST",
      headers: headers,
      body: JSON.stringify(body),
      keepalive: true,
    });

    if (!response.ok) throw new Error("Failed to download");
    // Get total file size from headers
    const contentType = response.headers.get("Content-Type");
    const contentLength = response.headers.get("Content-Length");

    if (!contentLength) {
      console.warn("No content-length header — progress will be inaccurate");
    }

    const total = parseInt(contentLength, 10);
    let loaded = 0;

    // Create a readable stream to track progress
    const reader = response.body.getReader();
    const chunks = [];

    while (true) {
      const { done, value } = await reader.read();

      if (done) break;

      chunks.push(value);
      loaded += value.length;

      // Progress callback (0–100)
      if (onProgress && total) {
        onProgress(Math.round((loaded / total) * 100));
      }
    }
    // Combine chunks → Blob
    const blob = new Blob(chunks, { type: contentType });

    // Generate safe download link
    const url = URL.createObjectURL(blob);

    const a = document.createElement("a");
    a.href = url;

    // Optional filename from response headers
    const contentDisposition = response.headers.get("Content-Disposition");

    let fileName = "downloaded-file";

    if (contentDisposition && contentDisposition.includes("filename=")) {
      fileName = contentDisposition.split("filename=")[1].replace(/"/g, "");
    }

    a.download = fileName;
    a.click();

    URL.revokeObjectURL(url);
  } catch (error) {
    console.error("Download failed:", error);
  }
};
